The grouping that the source falls under.

Currently, three types are defined:

- `PartnerUpload` indicates that the candidate was uploaded to SEEK from a partner system.
- `SeekApplication` indicates that the candidate applied for a position on the SEEK job board.
- `SeekPurchase` indicates that the candidate profile was purchased from SEEK Talent Search.
